import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Accordion } from 'react-accessible-accordion';
import { Link } from 'react-router-dom';

import Section from './Section';
import Navbar from '../shared/Navbar';
import Island from '../shared/Island';
import Title from '../shared/Title';
import Text from '../shared/Text';
import CTAButton from '../shared/CTAButton';
import FAQuestion from './FAQuestion';
import { breakpoints, palette } from '../../constants/styles';
import Footer from './Footer';
import ToolsSubset from '../shared/ToolsSubset';
import { mp, getCampaign } from '../../constants/utils';
import ScrollToTopOnMount from '../shared/ScrollToTopOnMount';
import TLDRFinauta from '../shared/TLDRFinauta';
import FloatingContact from '../shared/FloatingContact';
import { StyledCustomHr } from './ReferralLanding';
import ResultImage from '../shared/ResultImage';

const StyledValueProp = styled.div`
  position: relative;
  overflow: hidden;
`;

const StyledFirstSection = styled(Section)`
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 540px;

  ${breakpoints.tabletLandscape} {
    justify-content: space-evenly;
    flex-direction: row-reverse;
    min-height: 390px;
  }

  ${breakpoints.desktop} {
    height: 90vh;
  }
`;

const StyledSobreFinauta = css`
  margin-top: 100px;

  ${breakpoints.mobileLandscape} {
    margin-top: 130px;
  }

  ${breakpoints.tabletLandscape} {
    margin-top: 40px;
  }
`;

const Statement = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${breakpoints.tabletLandscape} {
    align-items: flex-start;
    max-width: 45%;
  }
`;

class ValuePropBase extends Component {
  state = {};

  componentDidMount = () => {
    mp(`[${getCampaign(window.location.href)}] | Retiro | Landing | Entra`);
  };

  render() {
    const {
      tool,
      title,
      titleStyles,
      message,
      mainTitleStyles,
      mainTitle,
      messageStyles,
      event,
      children,
    } = this.props;
    console.log(mainTitleStyles);
    console.log(titleStyles);
    return (
      <Fragment>
        <StyledValueProp>
          <ScrollToTopOnMount />

          <Navbar />
          <StyledFirstSection>
            <Title level={1} styles={mainTitleStyles}>
              {mainTitle}
            </Title>
            <ResultImage tool={tool} />
            <Statement>
              <Title level={3} styles={titleStyles}>
                {title}
              </Title>
              <CTAButton event={event} internalLink={`/${tool}/empezar`} buttonText="Empezar" />
              <Text style={{ color: '#9a9a9a', marginTop: '1em' }} styles={messageStyles} medium>
                {message}
              </Text>
            </Statement>
          </StyledFirstSection>
          <Section>
            {children && (
              <>
                <StyledCustomHr />
                {children}
              </>
            )}
          </Section>
          <Section>
            <Island type="firstToolLanding" />
            <Title level={3} styles={StyledSobreFinauta}>
              Sobre Finauta
            </Title>
            <TLDRFinauta />
          </Section>
          {/* <OtherToolsSection>
            <Island type="secondToolLanding" />
            <Title level={3}>Otras herramientas...</Title>
            <ToolsSubset currentTool={tool} styles={StyledSVGs} />
          </OtherToolsSection>
          <Section>
            <Island type="thirdToolLanding" />
            <Title level={3} styles={css`text-align: center;`}>Simplificamos tus finanzas personales</Title>
            <StyledTeamImage src={'https://s3.us-east-2.amazonaws.com/finauta/art/teamSmall.png'} />
            <CTAButton internalLink="/conocenos" buttonText="Conócenos" buttonStyles={StyledSecondaryValuePropCTA} event={`${tool} | FAQ`} />
          </Section> */}
        </StyledValueProp>
        <FloatingContact />
        <Footer />
      </Fragment>
    );
  }
}

ValuePropBase.propTypes = {
  tool: PropTypes.string,
  title: PropTypes.string,
  mainTitle: PropTypes.string,
  message: PropTypes.string,
  titleStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  mainTitleStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  messageStyles: PropTypes.object,
};

ValuePropBase.defaultProps = {
  tool: '',
  title: '',
  titleStyles: {},
  message: '',
  mainTitle: '',
  mainTitleStyles: {},
  messageStyles: {},
};

export default ValuePropBase;
